import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1857ccb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header_logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "header_text" }
const _hoisted_4 = { class: "header_lyaout_menu" }

import { useRouter } from 'vue-router';
import HeaderMenu from '@/components/HeaderMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderTypeC',
  props: {
  title: {
    type: String,
    default: '',
  },
  spHeaderBackLink: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props


const router = useRouter();

const goHome = () => {
  router.push({ name: 'f00' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(HeaderMenu)
      ]),
      (__props.spHeaderBackLink)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            onClick: goHome,
            class: "back_link"
          }, "ホーム"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})